export function exportFile(url: string, fileName: string) {
    const download = document.createElement("a");
    download.href = url;
    download.download = fileName;
    document.body.appendChild(download);
    download.click();
    download.remove();
}
